<script>
import { Pie } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import chartColors from './../libs/chartColors.definition.js';
import currency from './../libs/currency.js';

export default {
    extends: Pie,
    props: ['data'],

    mounted() {
        this.renderPieChart();
    },

    computed: {
        chartData() {
            return this.data;
        },
    },

    watch: {
        data() {
            this._chart.destroy();
            this.renderPieChart();
        },
    },

    methods: {
        backgroundColor() {
            if (!this.data) {
                return '#09b3af';
            }

            if (this.data.isBestseller) {
                return this.data.values.map((e, i, data) => {
                    if (i >= this.data.isBestseller) {
                        return '#9ce0df';
                    }
                    return '#09b3af';
                });
            }

            return this.data.values.length <= chartColors.length
                ? chartColors
                : '#09b3af';
        },

        renderPieChart() {
            const self = this;

            this.addPlugin(ChartDataLabels);
            this.renderChart(
                {
                    labels: (this.data && this.data.labels) || [],
                    datasets: [
                        {
                            borderWidth: 1,
                            color: '#fff',
                            backgroundColor: this.backgroundColor(),
                            data: (this.data && this.data.values) || [],
                        },
                    ],
                },
                {
                    legend: {
                        display: false,
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        callbacks: {
                            title: function (tooltipItem, data) {
                                return data['labels'][tooltipItem[0]['index']];
                            },
                            label: function (tooltipItem, data) {
                                let value =
                                    data['datasets'][0]['data'][
                                        tooltipItem['index']
                                    ];
                                const datapoints = self.data.values;
                                function totalSum(total, datapoint) {
                                    return total + datapoint;
                                }
                                const totalValue = datapoints.reduce(
                                    totalSum,
                                    0
                                );
                                const percentageValue =
                                    (value / totalValue) * 100;
                                switch (self.data.format) {
                                    case 'CURRENCY':
                                        value = currency(
                                            value,
                                            self.data.currency
                                        );
                                        break;
                                }
                                return (
                                    value +
                                    ' (' +
                                    percentageValue.toFixed(1) +
                                    '%)'
                                );
                            },
                        },
                        backgroundColor: '#FFF',
                        titleFontColor: '#09b3af',
                        bodyFontColor: '#000',
                        borderColor: '#09b3af',
                        borderWidth: 1,
                        displayColors: false,
                    },
                    plugins: {
                        datalabels: {
                            formatter: (value, context) => {
                                const datapoints =
                                    context.chart.data.datasets[0].data;
                                function totalSum(total, datapoint) {
                                    return total + datapoint;
                                }
                                const totalValue = datapoints.reduce(
                                    totalSum,
                                    0
                                );
                                const percentageValue =
                                    (value / totalValue) * 100;
                                return percentageValue === 0
                                    ? ''
                                    : `${percentageValue.toFixed(1)}%`;
                            },
                            color: 'white',
                            textAlign: 'center',
                            display: 'auto',
                        },
                    },
                }
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// ChartPie.vue?b16053f2